import script from "./NarcologyRecordTable.vue?vue&type=script&setup=true&lang=js"
export * from "./NarcologyRecordTable.vue?vue&type=script&setup=true&lang=js"

import "./NarcologyRecordTable.vue?vue&type=style&index=0&id=59496bc2&scoped=true&lang=scss"
script.__scopeId = "data-v-59496bc2"

export default script